<template>
  <div style="base">
    <inside-header title="添加孩子" />
    <van-form input-align="right" @submit="onSubmit">
      <!-- 姓名 -->
      <van-field v-model="username" required name="nick_name" label="姓名" placeholder="请输入姓名"
        :rules="[{ required: true, message: '请输入姓名' }]" />
      <!-- 性别选择 -->
      <van-field required readonly clickable name="sex" :value="sex" label="性别"
        :rules="[{ required: true, message: '请选择性别' }]" @click="showSex = true" />
      <van-popup v-model="showSex" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showSex = false" />
      </van-popup>
      <!-- <van-field
                readonly
                clickable
                name="barth_day"
                :value="birthDay"
                label="出生日期"
                @click="showBirthDay = true"
            />
            <van-popup v-model="showBirthDay" position="bottom">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm = "onBirthDayConfirm"
                    @cancel="showBirthDay = false"
                />
            </van-popup> -->
      <van-cell-group>
        <van-field v-model="subject" name="coach_subject" label="科目" placeholder="请输入欠缺科目" />
      </van-cell-group>
      <van-field required readonly clickable name="stage" :value="sta" label="所在阶段" placeholder="点击选择阶段"
        :rules="[{ required: true, message: '请输入所在阶段' }]" @click="showStage = true" />
      <van-popup v-model="showStage" position="bottom">
        <van-picker show-toolbar :columns="studentStage" @confirm="onStudentStage" @cancel="showStage = false" />
      </van-popup>
      <van-field v-model="message" rows="2" autosize label="描述信息" name="desc" type="textarea" maxlength="150"
        placeholder="请输入描述信息" show-word-limit />
      <van-field v-model="required" rows="2" autosize label="对教员的要求" name="require_desc" type="textarea" maxlength="150"
        placeholder="请输入对教员的要求" show-word-limit />
      <div style="text-align:center;margin-top:50px;">
        <van-button v-if="pageType === 'edit'" color="#ff5c00" native-type="submit" :loading="state.submitBtn"
          style="width:315px;border-radius:10px">
          保存
        </van-button>
        <van-button v-if="pageType === 'edit'" color="#ee0a24" native-type="button" :loading="state.delBtn"
          style="width:315px;border-radius:10px;margin-top:10px;" @click="goDelete(id)">
          删除
        </van-button>
        <van-button v-if="pageType === 'add'" color="#ff5c00" native-type="submit" :loading="state.submitBtn"
          style="width:315px;border-radius:10px">
          新增
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'UserAddChild',
  components: {
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      state: {
        submitBtn: false,
        delBtn: false
      },
      sex: '',
      username: '',
      columns: ['男', '女'],
      showSex: false,
      showDate: false,
      // 生日选择
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2015, 11, 31),
      currentDate: new Date(),
      showBirthDay: false,
      birthDay: '',
      // 科目
      subject: '',
      message: '',
      studentStage: ['小学', '初一二', '初三', '高一二', '高三'],
      showStage: false,
      sta: '',
      // 对教员的要求
      required: '',
      // 当前页面为修改还是添加
      pageType: 'add',
      info: []
    }
  },
  created() {
    console.log('student+id', this.id)
    if (this.id !== undefined && this.id !== '') {
      this.pageType = 'edit'
      this.loadData(this.id)
    }

    // 只有通过路由传参
    //   var student_id  = this.$route.query.id
    //   if(student_id !== undefined)

    //   this.$route.query  ===?  {}
    //   {
    //     id: 121,
    //     title: 'dfds'
    //   }
  },
  methods: {
    loadData(id) {
      this.$http({
        url: 'index/user/student',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          var info = data.info
          this.username = info.nick_name
          this.sex = info.sex
          this.subject = info.coach_subject
          this.sta = info.stage
          this.required = info.require_desc
          this.message = info.desc
        }
      })
    },
    onConfirm(value) {
      this.sex = value
      this.showSex = false
    },
    onBirthDayConfirm(value) {
      console.log(value)
      this.birthDay = value
      this.showBirthDay = false
      var d = new Date(value)
      this.birthDay = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    },
    onStudentStage(sta) {
      this.sta = sta
      this.showStage = false
    },
    goDelete() {
      this.state.delBtn = true
      // 提示信息
      this.$dialog.confirm({
        title: '注意',
        message: '确认后，将删除该学员相关的所有信息'
      }).then(() => {
        this.$http({
          url: 'index/user/studentDelete',
          method: 'post',
          data: {
            id: this.id
          }
        }).then(res => {
          this.state.delBtn = false
          if (res.status === 'success') {
            const _this = this
            this.$toast.success('删除学员成功')
            setTimeout(function () {
              _this.$router.push({ name: 'UserStudents' })
            }, 2000)
          } else {
            this.$toast.fail(res.message)
          }
        })
      })
    },
    onSubmit(values) {
      var url = ''
      // 判断当前为保存还是新增
      if (this.pageType === 'add') {
        url = '/index/user/studentCreate'
      } else {
        url = '/index/user/studentSave'
        values.id = this.id
      }
      this.state.submitBtn = true
      console.log('submit', values)
      this.$http({
        url: url,
        method: 'post',
        data: values
      }).then(res => {
        this.state.submitBtn = false
        if (res.status === 'success') {
          this.$toast.success('保存成功')
          const that = this
          setTimeout(function () {
            that.$router.push({ name: 'UserStudents' })
          }, 2000)
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }

}
</script>
<style lang="stylus" scoped>

</style>
